import { useState } from 'react'
import useFetch from '../hooks/useFetch'
import { apiWrapper } from './dataHookUtils'

export default () => {
  const [isLoading, setIsLoading] = useState(false)
  const [eventProducts, setEventProducts] = useState(true)
  const [shareLogistics, setShareLogistics] = useState()
  const [validateShareLogistics, setValidateShareLogistics] = useState()

  const fetch = useFetch()

  const postHeaders = { "Content-Type": "application/json" }

  const fetchEvent = async (eventId) => {
    return apiWrapper({
      fetch,
      url: `events/event?id=${eventId}`,
      options: {
        method: 'GET'
      }
    });
  }

  const fetchEventIdByCode = async (code) => {
    return apiWrapper({
      fetch,
      url: `events/event/eventByCode?code=${code}`,
      options: {
        method: 'GET'
      }
    });
  }

  const fetchEventProducts = async (eventId) => {
    try {
      setIsLoading(true)
      const results = await apiWrapper({
        fetch,
        url: `events/event/products?eventId=${eventId}`,
        options: {
          method: 'GET',
        }
      });
      setEventProducts(results)
      return results
    } catch (e) {
      console.log(e)
      setEventProducts([])
      return []
    } finally {
      setIsLoading(false)
    }
  }

  const updateEvent = async (data) => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: `events/event/update`,
        options: {
          method: 'POST',
          headers: postHeaders,
          body: JSON.stringify({ data })
        }
      });
      const jsonData = result.json()
      if (!jsonData.success) {
        throw new Error('Error updating event')
      }
      return jsonData
    } catch (e) {
      console.log(e)
    } finally {
      setIsLoading(false)
    }
  }

  const updateEventDeliveryNotes = async (data) => {
    try {
      setIsLoading(true)
      return await apiWrapper({
        fetch,
        url: `events/event/update/deliveryNotes`,
        options: {
          method: 'POST',
          headers: postHeaders,
          body: JSON.stringify(data)
        }
      });
    } catch (e) {
      console.log(e)
    } finally {
      setIsLoading(false)
    }
  }

  const updateEventScheduleNotes = async (data) => {
    try {
      setIsLoading(true)
      return await apiWrapper({
        fetch,
        url: `events/event/update/scheduleNotes`,
        options: {
          method: 'POST',
          headers: postHeaders,
          body: JSON.stringify(data)
        }
      });
    } catch (e) {
      console.log(e)
    } finally {
      setIsLoading(false)
    }
  }

  const fetchShareLogistics = async (data) => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: `events/event/shareLogistics?eventId=${data.eventId}`
      });
      setShareLogistics(result)
      return result
    } catch (e) {
      console.log(e)
      setShareLogistics()
    } finally {
      setIsLoading(false)
    }
  }

  const fetchValidateShareLogistics = async (data) => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: `events/event/validateShareLogistics?key=${data.key}`
      });
      setValidateShareLogistics(result)
      return result
    } catch (e) {
      setValidateShareLogistics()
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,

    fetchEvent,
    fetchEventIdByCode,
    updateEvent,
    updateEventDeliveryNotes,
    updateEventScheduleNotes,

    eventProducts,
    fetchEventProducts,

    shareLogistics,
    fetchShareLogistics,
    validateShareLogistics,
    fetchValidateShareLogistics,
  }
}